import { render, staticRenderFns } from "./ObjectConifg.vue?vue&type=template&id=51827b83&scoped=true&"
import script from "./ObjectConifg.vue?vue&type=script&lang=js&"
export * from "./ObjectConifg.vue?vue&type=script&lang=js&"
import style0 from "./ObjectConifg.vue?vue&type=style&index=0&id=51827b83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51827b83",
  null
  
)

export default component.exports